import { GridToolbarContainer } from '@mui/x-data-grid-premium'
import { Box, Button } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import DeleteIcon from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'

const TrackingKeywordCustomToolbar = ({ controller, model }) => {
  const { t } = useTranslation()

  return (
    <GridToolbarContainer>
      <Button
        color='primary'
        startIcon={<ContentCopyIcon />}
        onClick={controller.handleCopyKeywords}
        disabled={model.selectionModel.length === 0}
      >
        {t('keywordsCopy')}
      </Button>

      {model.projectSelected && !model.projectSelected.url.includes('youtube') && (
        <Button
          className='onbTk-7'
          color={model.isAiOverview ? 'success' : 'primary'}
          startIcon={model.showAiOverview ? <VisibilityIcon /> : <VisibilityOffIcon />}
          onClick={() => model.setShowAiOverview((prev) => !prev)}
          disabled={!model.isAiOverview}
        >
          {t('aiOverview')}
        </Button>
      )}

      <Box sx={{ flexGrow: 1 }} />

      <Button
        color='error'
        startIcon={<DeleteIcon />}
        onClick={controller.handleOnDeleteSelection}
        disabled={model.selectionModel.length === 0}
      />
    </GridToolbarContainer>

  )
}

export default TrackingKeywordCustomToolbar;